import AdminVersionControlPage from './AdminVersionControlPage'
export default AdminVersionControlPage
